<template>
  <div class="mx-auto pb-16 max-w-screen-lg">
    <div class="pt-10 px-4 grid grid-cols-3 gap-3">
      <div class="col-span-3 md:col-span-2">
        <portal-collect-payment-card
          :invoice="invoice"
          :selected-payment-method="selectedPaymentMethod"
          @intent="intent = $event"
          @method-changed="selectedPaymentMethod = $event"
          @invoice-updated="$emit('invoice-updated', $event)"
        />
      </div>
      <div class="col-span-3 md:col-span-1">
        <div class="grid grid-cols-2 gap-3">
          <portal-invoice-detail-card
            :invoice="invoice"
            :intent="intent"
            :payment-method="selectedPaymentMethod"
          />
          <div class="col-span-2 sm:col-span-1 md:col-span-2 w-full">
            <portal-merchant-detail-card :invoice="invoice" />
            <div
              class="text-gray-400 text-xs mt-3"
              v-if="viewportWidth >= 768"
            >
              <ion-icon name="lock-closed-outline" />
              Your payment information is protected and kept confidential.
            </div>
          </div>
        </div>
        <div
          class="text-gray-400 text-xs mt-3 w-full text-center"
          v-if="viewportWidth < 768"
        >
          <ion-icon name="lock-closed-outline" />
          Your payment information is protected and kept confidential. Powered by Rainforest
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PortalCollectPaymentCard from "./PortalCollectPaymentCard.vue"
import PortalInvoiceDetailCard from "./PortalInvoiceDetailCard.vue"
import PortalMerchantDetailCard from "./PortalMerchantDetailCard.vue"

export default {
  name: "PortalInvoicePayment",

  components: { PortalInvoiceDetailCard, PortalCollectPaymentCard, PortalMerchantDetailCard },

  props: { invoice: { type: Object, required: false, default: () => ({}) } },
  emits: ["invoice-updated"],

  data() {
    return {
      company: window.FinancialCents.company || null,
      viewportWidth: window.innerWidth,
      intent: null,
      selectedPaymentMethod: null,
    }
  },

  computed: {
    customBranding() {
      if (!this.company) {
        return false
      }
      return this.company.custom_branding === true
    },
  },

  mounted() {
    window.addEventListener("resize", this.handleResize)
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize)
  },

  methods: {
    handleResize() {
      this.viewportWidth = window.innerWidth
    },
  },
}
</script>
